import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { Achievement } from './achievement';
import { Game } from './game';
import { TournamentStage } from './tournament-stage';

@ModelInstance({
  mappingFields: {
    id: 'id',
    achievement: 'achievement',
    tournament_stage: 'tournamentStage',
    team_id: 'teamId',
    game: 'game',
    mt_points: 'mtPoints',
  },
  relation: {
    achievement: Achievement,
    tournamentStage: TournamentStage,
    game: Game
  }
})
export class TeamAchievement extends BaseModel {
  id: number;
  teamId: number;
  achievement: Achievement;
  game: Game;
  tournamentStage: TournamentStage;
  mtPoints: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
